export default __webpack_public_path__ + "static/media/labnotes__imagotipo--negativo_1.93e3c453.png";